<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align: left">{{ props.item.name }}</td>
          <td style="text-align: left">{{ props.item.company }}</td>
          <td style="text-align: left">{{ props.item.email }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    name: "distribution-list-ext",

    data() {
      return {
        headers: [
          { text: this.$t("vessel.columnName"), value: "name" },
          { text: this.$t("vessel.company"), value: "company" },
          { text: this.$t("vessel.email"), value: "email" },
        ],

        currentMainDprId: null,
        currentPVId: null,
      };
    },
    computed: {
      ...mapGetters([
        "mv_dListExternal/getDListExternals",
        "mv_dprData/getDprPVId",
        "mv_dprData/getCurrentDprMainId",
      ]),
      items() {
        return this["mv_dListExternal/getDListExternals"];
      }
    },
    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this["mv_dListExternal/fetchDListExternalsByDprId"](this.currentMainDprId);
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "mv_dListExternal/fetchDListExternalsByDprId"
      ]),
    },
  };
</script>
<style scoped>
  .container {
    max-width: 95%;
  }
</style>
